import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PartyDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-party',
  templateUrl: './party.component.html',
  styleUrls: ['./party.component.scss']
})
export class PartyComponent implements OnChanges {


  partyForm: FormGroup;
  partyFormArray: FormGroup;
  control = new FormControl();
  @Input() parties: PartyDto[];
  @Input() routeAnimationsElements: any;
  @Output() party = new EventEmitter<PartyDto[]>()
  @Output() deletePartyEvent = new EventEmitter<any>()

    selectedParty: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createPartyForm();
    }

    createPartyForm() {
      this.partyForm = this.fb.group({
        PartyName: ['', Validators.required],
        PartyGroup: [''],
        id: null
        });
        this.partyFormArray = this.fb.group({ Parties: this.fb.array([])
          });
        this.setParty();
    }

  // method to display parties
  setParty() {
    const control  = this.partyFormArray.controls.Parties as FormArray;
    this.parties.forEach( e => {
      control.push(
        this.fb.group({
          PartyName: e.PartyName,
          PartyGroup: e.PartyGroup,
          id: e.id
        })
      );
    });
  }


  // method to add Party
  addParty(value: PartyDto) {
    const control  = this.partyFormArray.controls.Parties as FormArray;
    control.insert(0,
          this.fb.group({
            PartyName: value.PartyName,
            PartyGroup: value.PartyGroup,
            id: null
          })
       );
  }

  selectParty(value) {}

  // method to delete party from arrary list
  deleteParty(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.partyFormArray.controls.Parties as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.parties.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.parties[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: PartyDto) {
    if(this.partyForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.partyFormArray.get('Parties')['controls'][this.selectedIndex].patchValue({
        PartyName: formValue.PartyName,
        PartyGroup: formValue.PartyGroup,
      });
    } else {
      this.addParty(formValue);
    }
    this.selectedIndex = null;
    this.partyForm.reset()
  }

  onEdit(index, value: PartyDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.partyForm.patchValue({...value});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.partyForm.reset();
  }

  onSubmit(formValue: PartyDto[]) {
  this.party.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deletePartyEvent.emit(this.filteredDelete);
  }
  }

}
